import styled from "styled-components";

export const StyledSkeletonItem = styled.div`
  width: 100%;
`;
